import i18n from "@/locales/index";
const _t = i18n.global.t;

export const hourList = () => {
    return [
      {key: '0', value: '00:00:00'},
      {key: 1, value: '01:00:00'},
      {key: 2, value: '02:00:00'},
      {key: 3, value: '03:00:00'},
      {key: 4, value: '04:00:00'},
      {key: 5, value: '05:00:00'},
      {key: 6, value: '06:00:00'},
      {key: 7, value: '07:00:00'},
      {key: 8, value: '08:00:00'},
      {key: 9, value: '09:00:00'},
      {key: 10, value: '10:00:00'},
      {key: 11, value: '11:00:00'},
      {key: 12, value: '12:00:00'},
      {key: 13, value: '13:00:00'},
      {key: 14, value: '14:00:00'},
      {key: 15, value: '15:00:00'},
      {key: 16, value: '16:00:00'},
      {key: 17, value: '17:00:00'},
      {key: 18, value: '18:00:00'},
      {key: 19, value: '19:00:00'},
      {key: 20, value: '20:00:00'},
      {key: 21, value: '21:00:00'},
      {key: 22, value: '22:00:00'},
      {key: 23, value: '23:00:00'},
    ]
  } 

  // 素材管理上传文件的状态
export const uploadStatus = (status: number) => {
  // * 等待下载：-1（收到上传消息）
  // * 下载中：0-99（实时进度）
  // * 正在配置：100（下载完成）
  // * 同步完成：200（整个下载、保存数据库全过程结束）
  // * 同步失败：500
  let currentStatus = status + '%'
  if(status == 500)  currentStatus = _t('ad.syncFail')
  if(status == 200)  currentStatus = _t('ad.syncComplete')
  if(status == 100)  currentStatus = _t('ad.syncComplete')
  if(status == 101)  currentStatus = _t('ad.waitForDownload')
  if(status == 102)  currentStatus = _t('ad.startDownload')
  if(status == -1)  currentStatus = _t('ad.downloadWaiting')
  if(status == 501)  currentStatus = _t('ad.downloadWaiting')
  return currentStatus
}

export const showStatus = (status: number) =>{
  let currentStatus = status + '%'
  if(status == 500)  currentStatus = _t('ad.fail')
  if(status == 200)  currentStatus = _t('ad.complete')
  if(status == 100)  currentStatus = _t('ad.complete')
  return currentStatus
}